import { useEffect } from "react";

import { Chip } from "@material-ui/core";
import { Done } from "@material-ui/icons";
import moment from "moment";

import { SelectValidatorGeneric } from "../atomic/atoms/Select"
import { TemplateMigrateFiles } from "../atomic/templates/TemplateMigrateFiles"
import { useSurge } from "../../hooks/useCases/useSurge";
import { useValidationForm } from "../../hooks/useValidationForm";

export const ArchivosRecuperos = () => {
  const surge = useSurge();
  const validations = useValidationForm();

  const tipoArchivos = surge.data.tipoArchivos.map(item  => ({
    value: item.id, 
    label: 'Cargar '+item.descripcion, 
    onClick: (file) => {
      const fileName = file.name.toLowerCase();
      if(validations([
        {
          errorCondition: !fileName.endsWith(".xlsx"),
          errorMessage: "Debe ingresar un archivo xlsx"
        }
      ]))surge.upload.archivoSolicitud(file, item.id)
    }
  }));

  const plantillas = surge.data.tipoArchivos.map(item  => ({
    value: item.id, 
    label: 'Plantilla '+ item.descripcion, 
    onClick: () => {
      surge.files.solicitudesSSS.plantillaExcel(item.id)
    }
  }));

  useEffect(() => {
    surge.clean.archivos();
    surge.get.all.tipoArchivos();
  }, []);
  console.log(surge.data.tipoArchivos);
  return (
    <TemplateMigrateFiles 
      title= "Archivos SURGE"
      buttons={tipoArchivos}
      templateButtons={plantillas}
      handleSearch={(values) => surge.get.byParameters.archivos(values)}
      behindDates={{
        value: { idTipoArchivo: 99 },
        Component: (formValues, setFormValues) => (
          <SelectValidatorGeneric 
            style={{border: "1px solid #ddd", borderRadius: 0}}
            label="Tipo Archivo"
            name="idTipoArchivo"
            value={formValues?.idTipoArchivo}
            onChange={(e) => { setFormValues({idTipoArchivo: e.target.value}) }}
            menuItems={[
              {
                value: 99,
                label: "Todos"
              },
              ...tipoArchivos
            ]}
          />
        )
      }}
      rowPerPage={50}
      list={surge.data.archivos}
      columns={[
        {
          id: "fileName",
          label: "Nombre de Archivo"
        },
        {
          label: "Fecha de Subida",
          customBody:(item) => moment(item.fecha).format("DD/MM/YYYY")
        },
        {
          id: "usuario.userName",
          label: "Usuario"
        },
        {
          id: "tipoArchivo.descripcion",
          label: "Tipo de Archivo"
        },
        {
          label: "Estado",
          customBody: () => (
            <Chip 
              icon={<Done style={{ color: "#fff" }} />} 
              label="Procesado correctamente" 
              style={{
                backgroundColor: "#30962C",
                color: "#fff"
              }} 
            />
          )
        },
      ]}
    />
  )
}
